export const QRCashApp = 'cash_app'

export const QRVenmo = 'venmo'

export const QRZelle = 'zelle'